"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectPayInResult = void 0;
const DirectPayIn_1 = require("../models/DirectPayIn");
class DirectPayInResult extends DirectPayIn_1.DirectPayIn {
    secureModeRedirectUrl;
    secureModeNeeded;
}
exports.DirectPayInResult = DirectPayInResult;
//# sourceMappingURL=DirectPayInResult.js.map